import { OktaAuth } from '@okta/okta-auth-js'
import oktaConfig from '../../credentials/okta';

class UserHelperConfig {
  // Ainda não implementado
  getUsernameLoginTypes() {
    return ['email', 'cpf', 'cnpj']
  }
  // Já implementado
  getUsernameCreateTypes() {
    return ['cpf', 'cnpj']
  }
  async checkUserExists(userData, userFirebaseDoc, screen, userHelper) {
    let code = 'user-does-not-exist';
    let oktaData = false;

    if(!userFirebaseDoc?.oktaData && !userFirebaseDoc?.oktaId && !userFirebaseDoc?.PasswordDefinitionIsRequired)
      return {
        haltProcess: true,
        success: true,
        oktaData,
        code,
      }

    if (userFirebaseDoc) {
      if(userFirebaseDoc?.isConsultant){
        code = 'user-consultant-exists';
        return {
          haltProcess: true,
          success: true,
          code,
        }
      }

      if (userFirebaseDoc?.UserFirebaseId) {
        if (userFirebaseDoc?.oktaId) {
         
          if (userFirebaseDoc?.PasswordDefinitionIsRequired) {
            code = userFirebaseDoc?.isConsultant ? 'user-consultant-exists' : 'user-needs-password-definition';
          }
          else {
            code = 'user-exists';
          }
          
        }
        else {
          code = 'user-needs-password-definition';
        }

      }
      else {
        code = 'unknown-error';
        if (userFirebaseDoc?.oktaData) {
          code = 'okta-user-exists';
          oktaData = userFirebaseDoc?.oktaData;
        } else {
          code = 'unknown-error';
        }
      }
    }

    if (
      (code === 'user-needs-password-definition') &&
      (!userFirebaseDoc?.oktaId || screen !== 'accesscode')
    ) {
      await userHelper.sendPasswordDefinitionRequire(userFirebaseDoc.UserFirebaseId);
    }
    return {
      haltProcess: true,
      success: true,
      oktaData,
      code,
    }
  }
  async definePassword(UserFirebaseId, AccessCode, password, username, userHelper) {
     if (username) {
        let oktaResult = await this.defineOktaPassword(UserFirebaseId, AccessCode, password,username, userHelper);

        if (oktaResult.success) {
          oktaResult.doLogin = false;
          oktaResult.username =false;
        }

        return oktaResult;
      }

    return false;
  }
  async defineOktaPassword(UserFirebaseId, AccessCode, password,username, userHelper) {
    if ((!UserFirebaseId && !username) || !AccessCode || !password) {
      return {
        success: false,
      }
    }

    // Alterando no OKTA
    const herokuData = {
      UserFirebaseId,
      AccessCode,
      cpfCnpj: username,
      locale: 'acessaAgro',
      password,
    }

    let oktaResponse = { errorCode: 999 };

    try {
      oktaResponse = await userHelper?.dataHelper?.api.post('/changeOktaUserPassword', herokuData)
      if (oktaResponse?.errorCode || !oktaResponse?.id) {
        let errorStatus = getOktaErrorMessage(oktaResponse);
        return {
          success: false,
          goBack: errorStatus.goBack,
          message: errorStatus.message,
        }
      }
      else {
        return {
          success: true,
          message: 'Definição de senha realizada com sucesso!',
        }
      }
    } catch (error) {
      console.log('defineOktaPassword', error);
      return {
        success: false,
      }
    }
  }

  async beforeLogin(firebaseUserIdDoc, password, options = {}) {
    let email = firebaseUserIdDoc.Email;
    let firebasePassword = hashCode(email + hashKey);

    let hasWrongPassword = false;

    try {
      await oktaLogin(email, password);

      return {
        success: true,
        message: 'Login realizado com sucesso!',
        replaceEmail: email,
        replacePassword: firebasePassword,
        options,
      }
    }
    catch (e) {
      let errorMessage = 'Não foi possível realizar login';
      if (e?.xhr?.responseText) {
        let responseJSON = JSON.parse(e.xhr.responseText);
        if (responseJSON?.errorSummary) {
          errorMessage = responseJSON.errorSummary;
        }
        if (responseJSON?.errorCode === "E0000004") {
          hasWrongPassword = true;
        }
      }

      return {
        success: false,
        message: errorMessage,
        ...(hasWrongPassword && {
          error: {
            code: "auth/wrong-password",
          }
        })
      }
    }
  }
  async beforeRecoverPassword(username, userFirebaseDoc, screen, userHelper) {
    let result = await this.checkUserExists(username, userFirebaseDoc, screen, userHelper);

    return result;
  }
  async checkEmailOktaExists(email, options = {}) {
    let { userHelper } = options;
    if (!email)
      return {
        success: false,
        errror: {
          code: 'missing-params',
        }
    };
    const data ={
      email: email
    }
    let result = false;

    try {
      const response = await userHelper?.dataHelper?.api.get(`/getOktaUser?${new URLSearchParams(data)}`)
      return response
    } catch (e) {
      result = {
        success: false,
        error: {
          code: 'okta-email-check-fail',
        }
      };
    }

    return result;
  }
  beforeCreateUser(userData, options = {}) {
    return {
      success: true,
      message: 'Pré-criação realizada com sucesso!',
      userData,
      options,
    }
  }
  async afterCreateUser(userData, options = {}) {
    const { AuthRegisterEmail, FirstName,  LastName, LoyaltyPhone__c, EmailIsReal, Email, OriginalPassword } = userData;
    const { userHelper } = options;

    
    // Criando no OKTA
    const herokuData = {
      firstName: FirstName,
      lastName: LastName,
      phone: LoyaltyPhone__c,
      email:  Email ,
      login: AuthRegisterEmail,
      Password: OriginalPassword,
    }

    let oktaResponse = { errorCode: 999 };
    try {
      oktaResponse = await userHelper?.dataHelper?.api.post('/createOktaUser', herokuData)
      if (oktaResponse?.errorCode || !oktaResponse?.id) {
        let errorStatus = getOktaErrorMessage(oktaResponse);
        return {
          success: false,
          goBack: errorStatus.goBack,
          message: errorStatus.message,
        }
      }
      else {
        if (!userData.UserFirebaseIdData) {
          userData.UserFirebaseIdData = {};
        }
        userData.UserFirebaseIdData.oktaId = oktaResponse.id;
  
        return {
          success: true,
          message: 'Pós-criação realizada com sucesso!',
          userData,
          options,
        }
      }
    }
    catch (e) {
      console.log('afterCreateUser',e)
      return {
        success: false
      }
    }
  }
  async beforeChangePassword(userData, options = {}) {
    let { Email, CurrentPassword, NewPassword } = userData;

    // Primeiro assegura que o login está correto
    let loginIsValid = false;
    let userId;
    try {
      let result = await oktaLogin(Email, CurrentPassword);

      if (result?.user?.id) {
        loginIsValid = true;
        userId = result.user.id;
      }
    }
    catch (e) {
      console.log('e', e);
    }

    if (!loginIsValid) {
      return {
        success: false,
        haltProcess: true,
        message: 'Senha atual inválida',
      }
    }

    // Alterando no OKTA
    let url = oktaConfig.url + 'api/v1/users/{USER_ID}/credentials/change_password';
    url = url.replace('{USER_ID}', userId);

    const rawResponse = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': oktaConfig.authId,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'oldPassword': { 'value': CurrentPassword },
        'newPassword': { 'value': NewPassword },
      })
    });

    const oktaResponse = await rawResponse.json();

    if (rawResponse.status === 200) {
      return {
        success: true,
        haltProcess: true,
        message: 'Sucesso',
      }
    }

    let errorMessage = 'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde';

    if (oktaResponse?.errorCauses[0]?.errorSummary) {
      errorMessage = getOktaErrorMessage(oktaResponse).message;
    }

    return {
      success: false,
      haltProcess: true,
      message: errorMessage,
    }
  }

  async setUserType(user) {
    if (!user?.acg_ProfileCodes__c) {
      return {
        userType: '',
        userTypes: [],
      }
    }

    // remover o lowercase caso isso já esteja implementado no lado do Salesforce
    let profilecode = user.acg_ProfileCodes__c.toLowerCase();

    let types = profilecode.split('_').filter(Boolean);

    // inverte a ordem para priorizar o tipo específico (ie consultor_focalpoint = focalpoint é o principal)
    types = types.reverse();

    let first_type = types[0];
    let camelTypes = types.map(type => camelize(type));

    return {
      userType: camelize(first_type),
      userTypes: camelTypes,
    }
  }
}

// Gera uma string determinística + fixo 'C0#' para cobrir requerimentos
const hashCode = function (str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36) + 'C0#';
};

const hashKey = 'uM5PzjqMB+OJX$SWmH4&pbAdrrOChy=nQ&FQM8Bj1c8cK5oO&Jye$2sj5qSS7NeD';

export default UserHelperConfig;

const camelize = (str) => {
  return str?.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return word.toUpperCase(); //index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

const oktaLogin = async (email, password) => {
  const oktaAuth = new OktaAuth({
    issuer: oktaConfig.url + 'oauth2/default',
    clientId: oktaConfig.clientId,
    redirectUri: window.location.origin + '/'
  });

  return await oktaAuth.signInWithCredentials({
    username: email,
    password: password
  });
}

const getOktaErrorMessage = (oktaResponse) => {
  let message = 'Não foi possível realizar esta operação';
  let goBack = true;
  let summary;

  if (oktaResponse?.errorSummary) {
    summary = oktaResponse.errorSummary;
  }

  if (oktaResponse?.errorCauses && oktaResponse?.errorCauses[0]?.errorSummary) {
    // password: This password was found in a list of commonly used passwords. Please try another password.
    // password: As exigências para a senha não foram atendidas. Password requirements: at least 8 characters, no parts of your username. Your password cannot be any of your last 4 passwords.
    // login: An object with this field already exists in the current organization
    // firstName: O campo está mal formado
    // You do not have permission to perform the requested action
    summary = oktaResponse.errorCauses[0].errorSummary;
  }

  if (summary) {
    // TODO - Especificar requerimentos para senha
    // Ex summary = 'As exigências para a senha não foram atendidas. Password requirements: at least 8 characters, no parts of your username. Your password cannot be any of your last 4 passwords.'
    if (summary.includes('password:') || summary.includes('Password requirements')) {
      message = 'Senha muito fraca. Tente não incluir partes de seu CPF, e-mail, ou palavras-chave como "Syngenta" e "Acessa Agro".';
      goBack = false;
    }
    else if (summary.includes('login:')) {
      message = 'Não foi possível criar usuário com este e-mail. Por favor, tente outro e-mail.';
      goBack = false;
    }
    else if (summary.includes('firstName')) {
      message = 'Campo de nome está mal formulado';
      goBack = false;
    }
    else if (summary.includes('lastName')) {
      message = 'Campo de sobrenome está mal formulado';
      goBack = false;
    }
    else {
      switch (summary) {
        case 'This password was found in a list of commonly used passwords. Please try another password.':
          message = 'Senha muito fraca. Tente não incluir partes de seu CPF, e-mail, ou palavras-chave como "Syngenta" e "Acessa Agro".';
          goBack = false;
          break;
        case 'Password has been used too recently':
          message = 'Senha usada recentemente. Por favor, insira uma nova senha';
          goBack = false;
          break;
        case 'You do not have permission to perform the requested action':
          message = 'Ocorreu um erro inesperado. [PERM]';
          break;
        default:
          break
      }
    }
  }

  return { message, goBack };
}